<script>
  import { redirect } from "@sveltech/routify";
  $redirect("../details");
</script>
